import { DEAL_STATUS, DEAL_STATUS_ORDER, type DealStatus } from '../constants/dealTracker';

/** True when re-follow from an inbox thread still needs Contacted marked complete. */
export function inboxRefollowNeedsContacted(status: DealStatus | string | undefined): boolean {
  if (!status || !DEAL_STATUS_ORDER.includes(status as DealStatus)) return true;
  return (
    DEAL_STATUS_ORDER.indexOf(status as DealStatus) <
    DEAL_STATUS_ORDER.indexOf(DEAL_STATUS.contacted)
  );
}
